/*global fbq*/
/*global dataLayer*/
var TRACKING_CATEGORY = 'ViewContent';

function toNumber(val) {
    var n = Number(String(val || '0').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : 0;
}


$('a[data-analytics="nav-donation-1"]')
  .off('click.fbeventsDonationView')
  .on('click.fbeventsDonationView', function() {
    window.dataLayer = window.dataLayer || [];
    
    var activeTabText = $('#pills-tab a.active').text().trim().toLowerCase();
    var donationType = activeTabText.indexOf('month') > -1 ? 'monthly' : 'one_time';
    var name = (donationType === 'monthly' ? 'Monthly' : 'One-Time') + ' Donation';
    
    // Grab whichever donation amount radio is checked in the active tab (one-time or monthly)
    var $checked = $('.maf-donation-component #pills-tabContent .tab-pane.active.show input:checked');
    var id = $checked.length ? $checked[0].id : 'DONATION';
    var donationValueRaw = $checked.length ? $checked.val() : '0';
    var donationValue = toNumber(donationValueRaw);
    // Avoiding sending '0' value
    if (!donationValue) {
        return;
    }

    var currency = 'USD';
    var item_type = donationType;     // "monthly" or "one_time"
    var item_category = "Donation";
    var o = {
        donation_amount:    donationValue,
        currency:      currency,
        item_name:     name,
        item_type:     item_type,
        item_category: item_category,
        item_ids:      id
    };
    
    console.log('ViewContent', o);
    fbq('track', TRACKING_CATEGORY, o);
    
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
    event: 'view_item',
    donation_only: true,
    donation_flow: 'modal',
    ecommerce: {
        currency: currency,
        value: donationValue,
        items: [{
        item_id: String(id || 'DONATION'),
        item_name: String(name || 'Donation'),
        item_brand: 'MedicAlert',
        item_category: String(item_category || 'Donation'),
        item_category2: String(item_type || ''), // monthly | one_time
        price: donationValue,
        quantity: 1
        }]
    }
    });

});
